import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

import { DatePicker, Label } from '@d-lighted/design-system';

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DropDownContent = styled.div`
  display: ${props => (props.showDropdown ? 'block' : 'none')};
  position: absolute;
  margin-top: 5px;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  transform: translate(50%, -100%);
  top: 10px;
  right: 50%;

  &::after {
    content: '';
    width: 25px;
    height: 25px;
    background: white;
    position: absolute;
    right: 20%;
    top: 95%;
    border-radius: 5px;
    transform: rotate(45deg);
    box-shadow: 10px 10px 15px -2px rgb(0 0 0 / 20%);
  }
`;

const DateLabel = styled(Label)`
  cursor: pointer;
  display: block;
  color: #68878d;
  font-size: 15px;
  margin-right: 5px;
  margin-bottom: 10px;
`;

const DateText = styled(Label)`
  cursor: pointer;
  display: block;
  color: #314143;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  padding-left: 0;
`;

const DatePickerButton = styled.div`
  cursor: pointer;
  padding: 5px 15px;
  border: 1px solid #d2e9e7;
  border-radius: 5px;
  width: calc(100% - 30px);
  background-color: white;
  margin-bottom: 5px;

  ${props =>
    props.focused &&
    `
   border: solid 1px #00bbb5;
   box-shadow: 1px 1px 5px #00bbb5, -1px -1px 5px #00bbb5;
    `}

  &:hover {
    color: red;
  }
`;
const SmallCalendar = ({
  id,
  labelLeft,
  placeholder,
}) => {
  const [calendar, showCalendar] = useState(false);
  const [focused, changedFocused] = useState(false);
  const [date, setDate] = useState(moment().toDate());
  const handleClickOutside = event => {
    const targetElement = event.target;
    if (
      !targetElement.matches(`#custom_field_${id}`) &&
      !targetElement.parentElement?.matches(`#custom_field_${id}`) &&
      !targetElement.parentElement?.closest('.dropdown-content')
    ) {
      showCalendar(false);
      changedFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDateChanged = newValue => {
    showCalendar(false);
    changedFocused(false);
    setDate(newValue);
  };

  const onDatePickerClicked = () => {
    showCalendar(!calendar);
    changedFocused(!focused);
  };
  return (
    <DropdownWrapper>
      <DateLabel>{labelLeft}</DateLabel>
      <DatePickerButton
        id={`custom_field_${id}`}
        onClick={onDatePickerClicked}
        focused={focused}
      >
        <DateText>
          {date
            ? moment(date).format('YYYY/MM/DD')
            : placeholder || 'Please select a date'}
        </DateText>
      </DatePickerButton>
      <DropDownContent className="dropdown-content" showDropdown={calendar}>
        <DatePicker
          style={{ width: 'auto' }}
          highlightWeek={false}
          value={date}
          width="320px"
          selectPast
          onChange={onDateChanged}
          showActionButton={false}
          id={`custom_field_${id}`}
        />
      </DropDownContent>
    </DropdownWrapper>
  );
};

SmallCalendar.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  labelLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default SmallCalendar;
